document.addEventListener('DOMContentLoaded', () => {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Kept in step with the unit's rise in the stylesheet: same base delay, same
     0.1s gap per unit, duration matched to the transform. */
  const COUNT_BASE = 150;
  const COUNT_STEP = 100;
  const COUNT_DUR = 900;

  const NUMBER = /(\d[\d,]*(?:\.\d+)?)/;

  /* Values are free text — "25", "33.2K+", "6Mo.", "85–95%" — so every number in
     the string is counted and everything around it is left exactly as authored.
     A range counts both of its numbers on the same curve. */
  function prepare(root) {
    return Array.prototype.map
      .call(root.querySelectorAll('[data-se-count]'), (el, i) => {
        const parts = el.textContent.split(NUMBER);
        const nums = [];

        parts.forEach((part, at) => {
          if (!NUMBER.test(part) || !/^\d/.test(part)) return;
          const decimals = (part.split('.')[1] || '').length;
          nums.push({
            at: at,
            target: parseFloat(part.replace(/,/g, '')),
            decimals: decimals,
            grouped: part.indexOf(',') > -1
          });
        });

        if (!nums.length) return null; // nothing numeric, leave it alone
        return { el: el, parts: parts, nums: nums, delay: COUNT_BASE + i * COUNT_STEP };
      })
      .filter(Boolean);
  }

  function draw(counter, progress) {
    const out = counter.parts.slice();

    counter.nums.forEach((num) => {
      const value = num.target * progress;
      let text = num.decimals ? value.toFixed(num.decimals) : String(Math.round(value));
      if (num.grouped) text = Number(text).toLocaleString('en-US');
      out[num.at] = text;
    });

    counter.el.textContent = out.join('');
  }

  function run(counters) {
    const ease = (t) => 1 - Math.pow(1 - t, 3);
    let start = null;

    function frame(now) {
      if (start === null) start = now;
      let running = false;

      counters.forEach((counter) => {
        const t = (now - start - counter.delay) / COUNT_DUR;
        if (t < 1) running = true;
        draw(counter, ease(Math.min(1, Math.max(0, t))));
      });

      if (running) requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function initSection(root) {
    if (root.dataset.seInit) return;
    root.dataset.seInit = 'true';

    if (REDUCED_MOTION || (window.Shopify && window.Shopify.designMode)) {
      root.classList.add('is-static', 'is-inview');
      return; // values stay exactly as authored
    }

    const counters = prepare(root);
    counters.forEach((counter) => draw(counter, 0));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          entry.target.classList.add('is-inview');
          run(counters);
        });
      },
      { threshold: 0.25, rootMargin: '0px 0px -60px 0px' }
    );

    observer.observe(root);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sych-evidence-stats]').forEach(initSection);
  }

  init(document);

  document.addEventListener('shopify:section:load', (event) => init(event.target));
});
